export abstract class Params {
  // 平台/项目的域名
  service?: string
  // 账号类型
  accountType: AccountType
  // 由CAPTCHA（验证码）服务通过验证后返回的token
  captchaToken?: string
}

/**
 * 客户端: 1:web、2:app、3: wechat 小程序
 */
export enum ClientType {
  web = 1,
  app,
  wechat
}

export class SendMessageParams extends Params {
  // 电话号码
  phoneNumber: string
  client?: ClientType = ClientType.web
}

export class ShortMessageLoginParams {
  // 电话号码
  phoneNumber: string
  // 短信码
  smsCode: string
  // 是否长期有效？ 长期是几天有效，由平台/项目在后端指定，前端只传标识
  longTerm: boolean
}

/**
 * 登录参数
 */
export class LoginParams extends Params {
  // 账号
  account: string
  // 密码
  password: string
  // 是否长期有效？ 长期是几天有效，由平台/项目在后端指定，前端只传标识
  longTerm: boolean
}

/**
 * 账号类型
 */
export enum AccountType {
  // 运营域
  admin = '2',
  // 客户域
  customer = '1'
}
